import React from 'react'

import { DataGrid, TColumnDef, Typography } from '@pnld/components-web'

import { IData, ITableProps, TStages } from './types'

const stagesMap = {
  educacaoInfantil: 'Educação Infantil',
  ensinoFundamental: 'Ensino Fundamental',
  ensinoMedio: 'Ensino Médio',
  cursoTecnico: 'Curso Técnico',
  eja: 'EJA',
}

type StageRowProps = { row: IData }

const StageCell: React.FC<StageRowProps> = ({ row }) => (
  <Typography variant="b-sm" color="brand.neutral.dark_2">
    {row.stage}
  </Typography>
)

const TotalCell: React.FC<StageRowProps> = ({ row }) =>
  row.isTotal ? (
    <Typography
      variant="b-sm"
      color="brand.neutral.dark_2"
      sx={{ fontWeight: 'bold' }}
    >
      Total
    </Typography>
  ) : null

const NumberCell: React.FC<{ value: number; isTotal: boolean }> = ({
  value,
  isTotal,
}) => (
  <Typography
    variant="b-sm"
    color="brand.neutral.dark_2"
    sx={{ fontWeight: isTotal ? 'bold' : 'normal' }}
  >
    {value.toLocaleString('pt-BR')}
  </Typography>
)

// O DataGrid renderiza `cell` como componente: uma função nova a cada render
// remonta a célula. Por isso o componente memoriza as colunas.
const buildStagesColumns = (id: TStages): Array<TColumnDef<IData>> => [
  {
    accessorKey: 'stage',
    header: `Etapas de ensino - ${stagesMap[id] || ''}`,
    cell: ({ row }) => <StageCell row={row.original} />,
  },
  {
    id: 'total',
    cell: ({ row }) => <TotalCell row={row.original} />,
  },
  {
    accessorKey: 'census',
    header: 'Censo',
    cell: ({ row }) => (
      <NumberCell value={row.original.census} isTotal={row.original.isTotal} />
    ),
  },
  {
    accessorKey: 'h1',
    header: 'QT1',
    cell: ({ row }) => (
      <NumberCell value={row.original.h1} isTotal={row.original.isTotal} />
    ),
  },
  {
    accessorKey: 'h2',
    header: 'QT2',
    cell: ({ row }) => (
      <NumberCell value={row.original.h2} isTotal={row.original.isTotal} />
    ),
  },
]

const StagesTable: React.FC<ITableProps> = ({ id, data }) => {
  const columns = React.useMemo(() => buildStagesColumns(id), [id])

  return <DataGrid columns={columns} data={data} hasPagination={false} />
}

export default StagesTable
